"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var command_expander_1 = require("../../command-expander");
exports.vectorArrow = command_expander_1.lookupOrAppend({}, "\u20D7");
//# sourceMappingURL=vectorArrow.js.map